import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';
import { connect } from 'react-redux'
import { setBoothFileList } from '../../actions/main'
import {PaperComponent} from '../../utils/Common'

const emails = ['username@gmail.com', 'user02@gmail.com'];

function BoothImportModal(props) {
  const { onClose, selectedValue, open } = props;
  var boothFileList = props.main.boothFileList;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    // onClose(value);
    var tmp = [...boothFileList];
    for(var i = 0; i <tmp.length; i++){
        if(tmp[i]['id'] == value){
            tmp[i] = {...tmp[i], active:!tmp[i]['active']};
        }
        else{
          tmp[i] = {...tmp[i], active:false}
        }
    }
    props.setBoothFileList(tmp)
    handleClose()
  };

  return (
    <Dialog 
      PaperComponent={PaperComponent}
      PaperProps={{drag_id:'boothimport-dialog-title'}}
      aria-labelledby="boothimport-dialog-title"
      onClose={handleClose} open={open}>
      <DialogTitle id='boothimport-dialog-title'>Select Booth File</DialogTitle>
      <List sx={{ pt: 0 }}>
        {boothFileList.map((boothFile, index) => (
          <ListItem button onClick={() => handleListItemClick(boothFile['id'])} key={index}>
            <ListItemText primary={<span style={boothFile['active']?{color:'green', fontWeight:'bold'}:{}}>{boothFile['filename']}</span>} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
}
const mapStateToProps = (state) => {
    return {
      main: state.main,
    };
  };
  
  const mapDispatchProps = (dispatch) => {
    return {   
      setBoothFileList: data=>dispatch(setBoothFileList(data)) 
    };
  };
  
export default connect(mapStateToProps, mapDispatchProps)(BoothImportModal);